export enum LogLevel {
    ERROR = 'error',
    WARN = 'warn',
    EVENT = 'event',
    INFO = 'info',
    DEBUG = 'debug',
    VERBOSE = 'verbose',
}

export const LOG_LEVELS = [
    LogLevel.ERROR,
    LogLevel.WARN,
    LogLevel.EVENT,
    LogLevel.INFO,
    LogLevel.DEBUG,
    LogLevel.VERBOSE,
];
